import React from 'react';
import '../Components/sidebar.css';
import { Link } from 'react-router-dom';
import { FaTimes } from 'react-icons/fa';

const Sidebar = ({ toggle, show }) => {
	const scrollTo = (id) => {
		const element = document.getElementById(id);

		toggle();
		element.scrollIntoView({
			behavior: 'smooth',
		});
	};
	return (
		<div className={`sideContainer ${show ? 'show' : ''}`}>
			
			{/* <div className="close" onClick={toggle}>
				Close
			</div> */}
			<div className="close" onClick={toggle}>
				<FaTimes />
			</div>

			<div className="sideMenu">


			<Link to="/" className="sideLink" onClick={() => scrollTo('Hero')}>
					Home
				</Link>

				 <Link to="/" className="sideLink" onClick={() => scrollTo('menu')}>    {/* link to='/' will help when we press the menu it ll jump 2 it */}
					Menu
				</Link>
				<Link to="/" className="sideLink" onClick={() => scrollTo('chefs')}>
					Staff
				</Link>

				{/* <Link to="/" className="sideLink">
					Custom cakes
				</Link> */}
				
				<Link to="/" className="sideLink" onClick={()=> scrollTo('contact')}>
					Contact
				</Link>

				<div className="btnWrap">
					{/* <div className="sideRoute">Book now</div> */}
					<button className="custom-btn btn-anim"><span>Book Now</span></button>
				</div>
			</div>
		</div>
		// <SidebarContainer isOpen={isOpen} onClick={toggle}>
		// 	<Icon onClick={toggle}>
		// 		<CloseIcon />
		// 	</Icon>

		// 	<SidebarMenu>
		// 		<SidebarLink to="/">Pizzas</SidebarLink>
		// 		<SidebarLink to="/">Desserts</SidebarLink>
		// 		<SidebarLink to="/">Full Menu</SidebarLink>
		// 	</SidebarMenu>

		// 	<SideBtnWrap>
		// 		<SidebarRoute to="/">Order Now</SidebarRoute>
		// 	</SideBtnWrap>
		// </SidebarContainer>
	);
};

export default Sidebar;
